import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

export interface TranslationField {
  key: string;
  label: string;
  type?: 'text' | 'textarea' | 'file';
}

@Component({
  selector: 'app-translation-form',
  templateUrl: './translation-form.component.html',
  styleUrls: ['./translation-form.component.scss']
})
export class TranslationFormComponent implements OnInit {
  @Input() fields: TranslationField[] = [];
  @Input() allowedLangs: string[] = [];
  @Input() value: any[] = [];
  @Output() valueChange = new EventEmitter<any[]>();

  form: FormArray;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.form = this.fb.array((this.value || []).map(row => this.createRow(row)));
    this.form.valueChanges.subscribe((val: any[]) => this.valueChange.emit(val));
  }

  private createRow(row: any = {}): FormGroup {
    const group: any = { lang: [row.lang || ''] };
    this.fields.forEach(f => {
      group[f.key] = [row[f.key] || ''];
    });
    return this.fb.group(group);
  }

  addRow() {
    this.form.push(this.createRow());
  }

  removeRow(index: number) {
    this.form.removeAt(index);
  }

  getRawValue(): any[] {
    return this.form.getRawValue();
  }
}
